import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/light.css'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import { Typography } from '@material-ui/core'
import QueryString from 'query-string'

import { defaultOrQueryDate } from '../../utils/QueryParser'

class DatePicker extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    input: {
      width: 300,
      font: 'inherit',
    },
    predefRange: {
      // backgroundColor: 'red',
      alignSelf: 'center',
      '&>a': {
        padding: theme.spacing(1),
        display: 'block',
        cursor: 'pointer',
      },
    },
  })

  onDateChange = (dates) => {
    if (dates.length === 2) {
      const { history, location } = this.props
      const from = dates[0]
      const to = dates[1]
      history.push({
        ...location,
        search: QueryString.stringify({
          from: moment(from).startOf('day').format(),
          to: moment(to).endOf('day').format(),
        }),
      })
    }
  }

  onReady = (_selectedDates, _dateStr, instance) => {
    const today = document.createElement('a')
    today.innerText = 'Today'
    today.addEventListener(
      'click',
      () => instance.setDate([moment().toDate(), moment().toDate()], true),
    )
    const yesterday = document.createElement('a')
    yesterday.innerText = 'Yesterday'
    yesterday.addEventListener(
      'click',
      () => instance.setDate([moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()], true),
    )
    const week = document.createElement('a')
    week.innerText = 'Last 7 days'
    week.addEventListener(
      'click',
      () => instance.setDate([moment().subtract(6, 'days').toDate(), moment().toDate()], true),
    )
    const month = document.createElement('a')
    month.innerText = 'Last 30 days'
    month.addEventListener(
      'click',
      () => instance.setDate([moment().subtract(29, 'days').toDate(), moment().toDate()], true),
    )
    const thisMonth = document.createElement('a')
    thisMonth.innerText = 'This month'
    thisMonth.addEventListener(
      'click',
      () => instance.setDate([moment().startOf('month').toDate(), moment().toDate()], true),
    )
    const lastMonth = document.createElement('a')
    lastMonth.innerText = 'Last month'
    lastMonth.addEventListener(
      'click',
      () => instance.setDate([
        moment().subtract(1, 'months').startOf('month').toDate(),
        moment().subtract(1, 'months').endOf('month').toDate(),
      ], true),
    )

    // then add some children
    const predefRanges = document.createElement('div')
    predefRanges.className = this.props.classes.predefRange
    predefRanges.appendChild(today)
    predefRanges.appendChild(yesterday)
    predefRanges.appendChild(week)
    predefRanges.appendChild(month)
    predefRanges.appendChild(thisMonth)
    predefRanges.appendChild(lastMonth)
    instance.calendarContainer.style.width = 'auto' // eslint-disable-line no-param-reassign
    instance.innerContainer.prepend(predefRanges)
  }

  render() {
    const {
      classes, location,
    } = this.props
    const [from, to] = defaultOrQueryDate(location.search)

    const flatpickrOptions = {
      mode: 'range',
      maxDate: moment().endOf('day').toDate(),
      altInput: true,
    }

    return (
      <Typography variant="subtitle1">
        <Flatpickr
          className={classes.input}
          options={flatpickrOptions}
          value={[from.toDate(), to.toDate()]}
          onChange={this.onDateChange}
          onReady={this.onReady}
        />
      </Typography>
    )
  }
}

export default withStyles(DatePicker.styles)(withRouter(DatePicker))
